import React, { useMemo } from "react";
import useSeverityAsPriority, {
  SeverityFieldsEnum,
} from "../../../General/useSeverityAsPriority";
import { formatNumber } from "@SeemplicityDev/shared";
import useAddRef, { UseAddRefOptions } from "../useAddRef";

interface AggregationsPageProps extends UseAddRefOptions {
  data?: {
    raw_findings_count: number;
    aggregated_findings_count: number;
    critical_findings_count: number;
    aggregated_critical_findings_count: number;
  };
}

const AggregationsPage: React.FC<AggregationsPageProps> = ({
  index,
  data,
  addRef,
}) => {
  const ref = useAddRef({ addRef });
  const { getSeverityField } = useSeverityAsPriority();

  const allFindingsDeductionPercentage = useMemo(() => {
    if (!data) {
      return 0;
    }
    return (
      100 -
      Math.round(
        (data?.aggregated_findings_count / data?.raw_findings_count) * 100
      )
    );
  }, [data?.aggregated_findings_count, data?.raw_findings_count]);

  const criticalFindingsDeductionPercentage = useMemo(() => {
    if (!data) {
      return 0;
    }
    return (
      100 -
      Math.round(
        (data?.aggregated_critical_findings_count /
          data?.critical_findings_count) *
          100
      )
    );
  }, [data?.aggregated_critical_findings_count, data?.critical_findings_count]);

  return (
    <div className={`eoy-page aggregations-page`} ref={ref}>
      <h3>Findings</h3>
      <h4>
        <span className="main">Efficient Prioritization: </span>
        <span className="sub">
          Smarter prioritization that transforms scale into focus and action
        </span>
      </h4>
      <div className="aggregations-container">
        <div className="raw-findings-container">
          {formatNumber(data?.raw_findings_count)} Raw Findings
        </div>
        <i className="seem-icon-next-arrow right-arrow" />
        <div className="aggregated-findings-container">
          {formatNumber(data?.aggregated_findings_count)} Findings
        </div>
      </div>
      <div className="deduction-container">
        {allFindingsDeductionPercentage}% Less Findings{" "}
        {criticalFindingsDeductionPercentage > 10 && (
          <React.Fragment>
            (<i className="seem-icon-arrow-down down-arrow" />
            {criticalFindingsDeductionPercentage}% Less{" "}
            <span
              className="critical-findings-deduction-percentage"
              style={{ color: getSeverityField(3, SeverityFieldsEnum.COLOR) }}
            >
              {getSeverityField(3, SeverityFieldsEnum.NAME)}
            </span>{" "}
            Findings)
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default AggregationsPage;
